module.exports = __webpack_public_path__ + "static/media/NUGGET.6a56fe2d.svg";